import { render, staticRenderFns } from "./RoomMirroringSidebar.vue?vue&type=template&id=00d41fd4&"
import script from "./RoomMirroringSidebar.vue?vue&type=script&lang=js&"
export * from "./RoomMirroringSidebar.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("/home/vsts/work/1/s/node_modules/vue-hot-reload-api/dist/index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('00d41fd4')) {
      api.createRecord('00d41fd4', component.options)
    } else {
      api.reload('00d41fd4', component.options)
    }
    module.hot.accept("./RoomMirroringSidebar.vue?vue&type=template&id=00d41fd4&", function () {
      api.rerender('00d41fd4', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "src/components/Room/Mirroring/RoomMirroringSidebar.vue"
export default component.exports